module.exports = __webpack_public_path__ + "img/nfc-trash.b63fb077.svg";